









































import Loading from 'vue-loading-overlay';
import { JourneysService } from '../../journeys/api/JourneysService';
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import { JourneysSummaryDataResponse } from '../../journeys/models/JourneysSummary';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';

@Component({
    components: { Loading }
})
export default class SettingsPreview extends Vue {
    @Prop() filterDate: FilterDateEvent;
    @Emit() handleRoute() {}

    mounted() {}

    @Emit() goToSettings() {}
}
